"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var lodash_1 = require("lodash");

var Factory_1 = require("./Factory");

var types_1 = require("../../types");

var SecurityToken_1 = require("../SecurityToken");

var TieredSto_1 = require("../TieredSto");
/**
 * Factory generates information for a tiered sto entity
 */


var TieredStoFactory =
/*#__PURE__*/
function (_Factory_1$Factory) {
  _inherits(TieredStoFactory, _Factory_1$Factory);

  /**
   * Create an instance of the tiered sto factory
   */
  function TieredStoFactory(context) {
    var _this;

    _classCallCheck(this, TieredStoFactory);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TieredStoFactory).call(this, TieredSto_1.TieredSto, context));

    _this.generateProperties = function (uid) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _TieredSto_1$TieredSt, securityTokenId, stoType, address, _SecurityToken_1$Secu, symbol, contractWrappers, module, _ref, _ref2, isPaused, capReached, isFinalized, beneficialInvestmentsAllowed, raisedFundsWallet, unsoldTokensWallet, numberOfTiers, minimumInvestment, nonAccreditedInvestmentLimit, _a, tokensSold, capPerTier, ratePerTier, fundsRaised, investorCount, isRaisedInETH, isRaisedInPOLY, isRaisedInSC, startDate, endDate, details, stableCoinAddresses, preIssueAllowed, tiers, rawTiers, _ref3, _ref4, fundraiseCurrencies;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _TieredSto_1$TieredSt = TieredSto_1.TieredSto.unserialize(uid), securityTokenId = _TieredSto_1$TieredSt.securityTokenId, stoType = _TieredSto_1$TieredSt.stoType, address = _TieredSto_1$TieredSt.address;
                _SecurityToken_1$Secu = SecurityToken_1.SecurityToken.unserialize(securityTokenId), symbol = _SecurityToken_1$Secu.symbol;
                contractWrappers = this.context.contractWrappers;
                _context.next = 5;
                return contractWrappers.moduleFactory.getModuleInstance({
                  name: contract_wrappers_1.ModuleName.UsdTieredSTO,
                  address: address
                });

              case 5:
                module = _context.sent;
                _context.next = 8;
                return Promise.all([module.paused(), module.capReached(), module.isFinalized(), module.allowBeneficialInvestments(), module.wallet(), contractWrappers.getTreasuryWallet({
                  module: module
                }), module.getNumberOfTiers(), module.minimumInvestmentUSD(), module.nonAccreditedLimitUSD(), module.getSTODetails()]);

              case 8:
                _ref = _context.sent;
                _ref2 = _slicedToArray(_ref, 10);
                isPaused = _ref2[0];
                capReached = _ref2[1];
                isFinalized = _ref2[2];
                beneficialInvestmentsAllowed = _ref2[3];
                raisedFundsWallet = _ref2[4];
                unsoldTokensWallet = _ref2[5];
                numberOfTiers = _ref2[6];
                minimumInvestment = _ref2[7];
                nonAccreditedInvestmentLimit = _ref2[8];
                _a = _ref2[9];
                tokensSold = _a.tokensSold;
                capPerTier = _a.capPerTier;
                ratePerTier = _a.ratePerTier;
                fundsRaised = _a.fundsRaised;
                investorCount = _a.investorCount;
                isRaisedInETH = _a.isRaisedInETH;
                isRaisedInPOLY = _a.isRaisedInPOLY;
                isRaisedInSC = _a.isRaisedInSC;
                startDate = _a.startTime;
                endDate = _a.endTime;
                details = __rest(_a, ["tokensSold", "capPerTier", "ratePerTier", "fundsRaised", "investorCount", "isRaisedInETH", "isRaisedInPOLY", "isRaisedInSC", "startTime", "endTime"]);
                _context.next = 33;
                return module.getUsdTokens();

              case 33:
                stableCoinAddresses = _context.sent;
                preIssueAllowed = false;

                if (!contract_wrappers_1.isUSDTieredSTO_3_1_0(module)) {
                  _context.next = 45;
                  break;
                }

                _context.next = 38;
                return Promise.all([module.preMintAllowed(), Promise.all(lodash_1.range(numberOfTiers).map(function (tier) {
                  return module.tiers({
                    tier: tier
                  });
                }))]);

              case 38:
                _ref3 = _context.sent;
                _ref4 = _slicedToArray(_ref3, 2);
                preIssueAllowed = _ref4[0];
                rawTiers = _ref4[1];
                tiers = rawTiers.map(function (_ref5) {
                  var tokenTotal = _ref5.tokenTotal,
                      totalTokensSoldInTier = _ref5.totalTokensSoldInTier,
                      rate = _ref5.rate,
                      soldDiscountPoly = _ref5.soldDiscountPoly,
                      tokensDiscountPoly = _ref5.tokensDiscountPoly,
                      rateDiscountPoly = _ref5.rateDiscountPoly;
                  return {
                    tokensOnSale: tokenTotal,
                    tokensSold: totalTokensSoldInTier,
                    price: rate,
                    tokensWithDiscount: tokensDiscountPoly,
                    tokensSoldAtDiscount: soldDiscountPoly,
                    discountedPrice: rateDiscountPoly
                  };
                });
                _context.next = 49;
                break;

              case 45:
                _context.next = 47;
                return Promise.all(lodash_1.range(numberOfTiers).map(function (tier) {
                  return module.tiers({
                    tier: tier
                  });
                }));

              case 47:
                rawTiers = _context.sent;
                tiers = rawTiers.map(function (_ref6) {
                  var tokenTotal = _ref6.tokenTotal,
                      mintedTotal = _ref6.mintedTotal,
                      rate = _ref6.rate,
                      tokensDiscountPoly = _ref6.tokensDiscountPoly,
                      mintedDiscountPoly = _ref6.mintedDiscountPoly,
                      rateDiscountPoly = _ref6.rateDiscountPoly;
                  return {
                    tokensOnSale: tokenTotal,
                    tokensSold: mintedTotal,
                    price: rate,
                    tokensWithDiscount: tokensDiscountPoly,
                    tokensSoldAtDiscount: mintedDiscountPoly,
                    discountedPrice: rateDiscountPoly
                  };
                });

              case 49:
                fundraiseCurrencies = [];

                if (isRaisedInETH) {
                  fundraiseCurrencies.push(types_1.Currency.ETH);
                }

                if (isRaisedInPOLY) {
                  fundraiseCurrencies.push(types_1.Currency.POLY);
                }

                if (isRaisedInSC) {
                  fundraiseCurrencies.push(types_1.Currency.StableCoin);
                }

                return _context.abrupt("return", Object.assign({
                  fundraiseCurrencies: fundraiseCurrencies,
                  raisedFundsWallet: raisedFundsWallet,
                  unsoldTokensWallet: unsoldTokensWallet,
                  raisedAmount: fundsRaised,
                  investorCount: investorCount,
                  soldTokensAmount: tokensSold,
                  startDate: startDate,
                  endDate: endDate
                }, details, {
                  securityTokenId: securityTokenId,
                  securityTokenSymbol: symbol,
                  tiers: tiers,
                  stoType: stoType,
                  address: address,
                  isPaused: isPaused,
                  capReached: capReached,
                  isFinalized: isFinalized,
                  preIssueAllowed: preIssueAllowed,
                  beneficialInvestmentsAllowed: beneficialInvestmentsAllowed,
                  minimumInvestment: minimumInvestment,
                  nonAccreditedInvestmentLimit: nonAccreditedInvestmentLimit,
                  stableCoinAddresses: stableCoinAddresses
                }));

              case 54:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };

    return _this;
  }

  return TieredStoFactory;
}(Factory_1.Factory);

exports.TieredStoFactory = TieredStoFactory;